import WhyChooseUs from "@/components/landing/homeEight/WhyChooseUs";
import Faqs from "@/components/landing/homeNine/Faqs";
import Banner from "@/components/landing/homeTen/Banner";
import BuiltInCrypto from "@/components/landing/homeTen/BuiltInCrypto";
import WhatYouNeed from "@/components/landing/homeTen/WhatYouNeed";
import freelancerSecurityFaqs from "@/data/faqFreelancerSecurity";

export default function HomeTen() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* What You Need section */}
      <WhatYouNeed />

      {/* Built In Crypto section */}
      <BuiltInCrypto />

      {/* Why Choose Us section */}
      <WhyChooseUs
        sectionTitle="Trust layers built around every payout"
        sectionDescription="Freelancer balances, logins, and withdrawals are guarded with the same controls used by regulated financial teams."
        itemLabels={[
          "Bank-grade encryption",
          "Real-time fraud signals",
          "Segregated safeguarding",
          "Human support 24/7",
        ]}
      />

      {/* Faqs section */}
      <Faqs
        sectionTitle="Security questions freelancers ask"
        sectionDescription="Straight answers about how OracleMarket keeps your money and identity protected."
        faqs={freelancerSecurityFaqs}
      />
    </>
  );
}
